export const LINK_TYPES = {
  DEFAULT: 'default',
  BLACK: 'black',
  WHITE: 'white',
  BTN_GHOST_WHITE: 'btn-ghost-white',
  BTN_BLACK: 'btn-black',
  BTN_GHOST_BLACK: 'btn-ghost-black'
}
